import React, { useEffect, useState } from "react";

import ButtonV2 from "../../../components/ui/button/v2";
import { CrossButton } from "../../../components/ui/button/v2/CrossButton";
import { cn } from "../../../lib/utils";

export interface StageWorkflowReturnCaseModalProps {
  isOpen: boolean;
  onClose: () => void;
  onReturnCase: (additionalInfo: string) => void;
  loading?: boolean;
  className?: string;
}

const StageWorkflowReturnCaseModal: React.FC<
  StageWorkflowReturnCaseModalProps
> = ({ isOpen, onClose, onReturnCase,loading, className }) => {
  const [additionalInfo, setAdditionalInfo] = useState("");

  useEffect(() => {
    if (!isOpen) setAdditionalInfo("");
  }, [isOpen]);

  const canReturn = additionalInfo.trim().length > 0;

  const renderTitle = () => (
    <div className="font-sans text-lg font-semibold leading-[100%] tracking-normal text-[#0A0A0A]">
      Return Case
    </div>
  );

  const renderLabel = () => (
    <div className="flex items-center gap-1 font-sans text-sm font-medium leading-[100%] tracking-normal text-[#0A0A0A]">
      <span>Additional Information</span>
      <span className="text-red-600">*</span>
    </div>
  );

  const renderTextArea = () => (
    <textarea
      value={additionalInfo}
      onChange={(e) => setAdditionalInfo(e.target.value)}
      placeholder="Enter details here..."
      disabled={loading}
      className={cn(
        "w-[560px] h-[100px] resize-none rounded-md border border-[#E5E5E5] bg-white px-3 py-1",
        "font-sans text-sm font-normal leading-5 text-[#0A0A0A]",
        "placeholder:font-sans placeholder:text-sm placeholder:font-normal placeholder:leading-5 placeholder:text-[#737373]",
        "focus:outline-none focus:ring-2 focus:ring-indigo-200",
      )}
    />
  );

  const handleReturnCase = () => {
    if (!canReturn) return;
    onReturnCase(additionalInfo);
  };

  const renderReturnButton = () => (
    <ButtonV2
      variant="primary"
      size="md"
      onClick={handleReturnCase}
      loading={loading}
      disabled={!canReturn}
      className={cn(
        "h-9 w-[115px] px-4 py-2 font-sans text-sm font-medium leading-5 text-white",
        !canReturn && "opacity-50 cursor-not-allowed",
      )}
    >
      Return Case
    </ButtonV2>
  );

  const renderFooter = () => (
    <div className="flex w-full justify-end">{renderReturnButton()}</div>
  );

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-[rgba(10,10,10,0.20)] flex items-center justify-center z-[9999]">
      <div
        className={cn(
          "relative bg-white border border-[#E5E5E5] rounded-lg shadow-lg p-6",
          "w-[608px] h-[256px]",
          "flex flex-col gap-4",
          className,
        )}
      >
                {<CrossButton onClick={onClose} disabled={loading}/>}
        {renderTitle()}

        <div className="flex flex-col gap-2">
          {renderLabel()}
          {renderTextArea()}
        </div>

        {renderFooter()}
      </div>
    </div>
  );
};

export default StageWorkflowReturnCaseModal;
